const uz = {
    meta: {
        title: "O'z dasturchisi yoki autsorsing: 12 oylik hisob | Innobek",
        description:
            "O'z dasturchisi, autsorsing va frilanser — 12 oylik to'liq xarajat taqqoslashi: ish haqi, soliq, ish joyi, ta'til, yuklanish darajasi va bilim yo'qolishi riski.",
        keywords: [
            "o'z dasturchisi yoki autsorsing",
            "IT autsorsing narxi O'zbekiston",
            "dasturchi ishga olish xarajati",
            "frilanser bilan ishlash riski",
            "IT jamoasini tashkil qilish",
            "dasturchi yillik tannarxi",
        ],
    },
    h1: "Dasturchi shtatda, autsorsingda yoki frilansda: 12 oylik hisob",
    lead:
        "Ko'p rahbar bu qarorni faqat ish haqi bilan hisoblaydi va yil oxirida byudjetdan chiqib ketadi. To'liq tannarxda soliq, ish joyi, ta'til va bo'sh vaqt ham bor. Quyida uch modelning 12 oylik taqqoslashi, yashirin xarajatlar va halol chegara — qachon haqiqatan o'z jamoangiz kerak.",
    category: "Loyiha iqtisodi",
    readingTime: "10 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Savol odatda shunday qo'yiladi: «dasturchini ishga olsam arzonroqmi yoki kompaniyaga bersammi?» To'g'ri javob raqamda, lekin raqamni to'liq yig'ish kerak. Quyida shu hisobning tayyor shakli bor — o'z summalaringizni qo'yib chiqing.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Nega bu savol 2026-yilda tez-tez chiqmoqda?" },
        {
            type: "p",
            text:
                "Chunki tizim endi bir marta qurilib qolmaydi. PP-190 qaroriga (23.05.2025) ko'ra 2026-yil 1-iyuldan markirovka qilingan tovar sotilganda markirovka kodi onlayn-kassa chekida majburiy aks etishi shart, ulgurji savdoda esa hisob-kitob faqat naqdsiz shaklda o'tkaziladi.",
        },
        {
            type: "p",
            text:
                "Ya'ni kassa dasturi, ombor va hujjat oqimi har chorakda o'zgarishga majbur. Shu sababli «kim qurdi» degan savol «kim qo'llab-quvvatlaydi» degan savoldan kamroq ahamiyatli bo'lib qoldi. Qaror shu nuqtadan boshlanadi.",
        },

        { type: "h2", text: "Uch modelning asosiy farqi nimada?" },
        {
            type: "p",
            text:
                "Farq narxda emas, xarajat tarkibida va risk kimda turishida. Buni bir gapda ifodalash mumkin.",
        },
        {
            type: "list",
            items: [
                "O'z dasturchisi — siz odamni sotib olasiz. Bilim ichkarida qoladi, lekin uning bo'sh vaqti, ta'tili va ketib qolishi ham sizniki.",
                "Autsorsing — siz natijani sotib olasiz. Soliq, texnika va almashtirish pudratchida qoladi, lekin bilimning bir qismi tashqarida bo'ladi.",
                "Frilanser — siz soatni sotib olasiz. Eng arzon start, lekin hujjat, kafolat va uzluksizlik bo'yicha eng zaif variant.",
            ],
        },
        {
            type: "p",
            text:
                "Universal g'olib yo'q. Bitta kompaniyada uchala model bir vaqtda ishlashi ham normal: doimiy mahsulot ichkarida, kampaniya sahifalari frilansda, integratsiya autsorsingda.",
        },

        { type: "h2", text: "O'z dasturchisining haqiqiy yillik tannarxi qanday hisoblanadi?" },
        {
            type: "p",
            text:
                "IT bo'yicha rasmiy o'rtacha ish haqi statistikasi alohida chop etilmaydi, shuning uchun quyidagi summa — o'quvchi o'z raqamini qo'yishi uchun misol, bozor kesimi emas. Soliq stavkalarini esa buxgalteringiz bilan amaldagi tahrirda tasdiqlang.",
        },
        {
            type: "ol",
            items: [
                "Qo'lga tegadigan ish haqi — misol uchun oyiga 12 000 000 so'm, ya'ni yiliga 144 000 000 so'm.",
                "Ish haqidan ushlab qolinadigan daromad solig'i va ish beruvchi to'laydigan ijtimoiy soliq ustiga qo'shiladi — bu misolda taxminan 39 000 000 so'm.",
                "Ish joyi: noutbuk, monitor, stol, litsenziyalar va ofis ijarasining ulushi — birinchi yilda odatda 25 000 000 – 35 000 000 so'm.",
                "Ishga qabul: vakansiya ochiq turgan 1–3 oy, suhbatlar, sinov muddati. Bu vaqt ishlab chiqarilmagan natija sifatida hisobga kirsin.",
                "Ta'til, kasallik va bayram kunlari: siz 12 oy to'laysiz, lekin haqiqatda ishlangan oy odatda 10,5 atrofida bo'ladi.",
            ],
        },
        {
            type: "p",
            text:
                "Shu besh banddan chiqadigan summa ko'pchilikni hayratda qoldiradi: 12 mln so'mlik ish haqi kompaniyaga yiliga 210–230 mln so'm atrofida tushadi. Ya'ni haqiqiy oylik tannarx e'lon qilingan ish haqidan taxminan 1,5 barobar yuqori.",
        },

        { type: "h2", text: "12 oylik taqqoslash jadvali" },
        {
            type: "p",
            text:
                "Quyida bitta middle darajasidagi dasturchi bir yil davomida kerak bo'lgan holat uchun uchta model taqqoslangan. Autsorsing raqamlari — Innobek narxlari; frilanser ustuni stavka bo'yicha juda keng tarqalgani uchun oraliq shaklida berilgan.",
        },
        {
            type: "table",
            head: ["Xarajat moddasi", "O'z dasturchisi", "Autsorsing", "Frilanser"],
            rows: [
                [
                    "Asosiy to'lov (12 oy)",
                    "144 000 000 so'm (qo'lga 12 mln/oy)",
                    "192 000 000 so'm (16 mln/oydan, to'liq bandlik)",
                    "Stavka bo'yicha, odatda eng past",
                ],
                [
                    "Soliq va ajratmalar",
                    "≈ 39 000 000 so'm",
                    "Kirmaydi — pudratchi tomonida",
                    "Shartnoma turiga bog'liq, ko'pincha rasmiylashtirilmaydi",
                ],
                [
                    "Texnika va ish joyi",
                    "25 000 000 – 35 000 000 so'm",
                    "Kirmaydi",
                    "Kirmaydi",
                ],
                [
                    "Ishga qabul va sinov muddati",
                    "1–3 oy natijasiz davr",
                    "1–2 haftada ishga kirishadi",
                    "Bir necha kun, lekin tekshiruvsiz",
                ],
                [
                    "Ta'til, kasallik, bayram",
                    "12 oydan ≈ 10,5 oy ishlanadi",
                    "Yo'qolgan vaqt o'rni pudratchida qoplanadi",
                    "To'lanmaydi, lekin muddat cho'ziladi",
                ],
                [
                    "Almashtirish riski",
                    "Ketsa — yana 1–3 oy va yangi tannarx",
                    "Shartnoma bo'yicha almashtiriladi",
                    "Yo'qolib qolsa, kafolat yo'q",
                ],
                [
                    "Yillik jami (taxminiy)",
                    "≈ 210 000 000 – 230 000 000 so'm",
                    "192 000 000 so'mdan (QQS alohida)",
                    "Eng past start, eng yuqori noaniqlik",
                ],
            ],
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Jadvalda ko'rinmaydigan bir narsani alohida ayting: autsorsing narxiga bulut serverlar, uchinchi tomon obunalari (to'lov tizimi, SMS, xarita, analitika) va tijorat litsenziyalari kirmaydi — ular sizning yuridik shaxsingizga rasmiylashtiriladi. O'z dasturchisi holatida esa bu xarajatlar baribir sizda qoladi.",
        },

        { type: "h2", text: "Dasturchi haqiqatda necha soat ishlaydi?" },
        {
            type: "p",
            text:
                "Bu — hisobdagi eng ko'p e'tibordan chetda qoladigan qism. Shtatdagi dasturchiga siz to'liq oy uchun to'laysiz, lekin loyiha uchun sarflangan soat kamroq bo'ladi.",
        },
        {
            type: "p",
            text:
                "Sabablari oddiy: yig'ilishlar, boshqa bo'limlarning mayda so'rovlari, texnik nosozliklarni tuzatish, kutish davrlari. Kichik kompaniyalarda dasturchi ko'pincha printer sozlash va Wi-Fi tuzatish bilan ham shug'ullanadi.",
        },
        {
            type: "p",
            text:
                "Shuning uchun taqqoslashda soat tannarxini hisoblang. 15 000 000 so'mlik to'liq oylik tannarx 100 soat real ishga to'g'ri kelsa, bitta soat 150 000 so'mga tushadi. Autsorsingdagi soatbay model esa 150 000 so'mdan boshlanadi, minimal hajm oyiga 20 soat — ya'ni kam yuklanishda tashqi model deyarli har doim arzonroq.",
        },

        { type: "h2", text: "Autsorsing: kuchli va zaif tomoni" },
        {
            type: "p",
            text:
                "Kuchli tomoni — tezlik va bashorat qilinadigan byudjet. Mutaxassis 1–2 haftada loyihaga kiradi, soliq va texnika bitta oylik summa ichida bo'ladi, byudjetda kutilmagan modda paydo bo'lmaydi.",
        },
        {
            type: "p",
            text:
                "Narx tarkibi ham ochiq. Innobek'da bitta mutaxassis to'liq bandlikda oyiga 16 000 000 so'mdan, 3–4 kishilik jamoa loyiha menejeri va texnik rahbar bilan 48 000 000 so'mdan, kengaytirilgan jamoa esa 110 000 000 so'mdan boshlanadi. Soatbay modelda stavka 150 000 so'mdan, minimal hajm oyiga 20 soat.",
        },
        {
            type: "p",
            text:
                "Zaif tomoni ikkita. Birinchisi — bilimning bir qismi tashqarida shakllanadi, shuning uchun hujjatlashtirish va repozitoriy sizning nomingizda bo'lishini shartnomaga yozib qo'yish shart. Ikkinchisi — minimal muddat bor: bitta mutaxassis uchun 2 oy, jamoa uchun 3 oy. Bir haftalik ish uchun bu model mos emas.",
        },

        { type: "h2", text: "Frilanser qachon mantiqiy, qachon qimmatga tushadi?" },
        {
            type: "p",
            text:
                "Frilanser bilan ishlash aniq bir toifa vazifalarda eng foydali yechim: hajmi kichik, natijasi ko'rinadigan va tugaydigan ish. Masalan bitta qo'nish sahifasi, logotip, bitta hisobot shakli.",
        },
        {
            type: "p",
            text:
                "Qimmatga tushadigan joy boshqa. Doimiy ishlaydigan tizim frilanserga berilsa, uch xil muammo chiqadi: hujjat yo'q, kod bo'yicha huquq noaniq, va odam istalgan kuni javob bermay qo'yishi mumkin. Shundan keyin yangi mutaxassis eski kodni tushunishga sarflaydigan vaqt ko'pincha loyihani qaytadan yozishdan arzon bo'lmaydi.",
        },
        {
            type: "callout",
            text:
                "Amaliy chegara: agar tizim to'xtaganda biznesingiz ham to'xtasa — bu frilanser vazifasi emas. Bunday tizimda kafolat, SLA va almashtirish majburiyati bo'lishi kerak.",
        },

        { type: "h2", text: "«Avtobus riski» nima va uni qanday kamaytirish kerak?" },
        {
            type: "p",
            text:
                "Bu IT'da keng tarqalgan atama: agar bitta odam ertaga ishga chiqmasa, loyiha qanchalik to'xtaydi? Yakka dasturchi bilan ishlagan kompaniyalarda javob odatda achchiq bo'ladi — to'liq to'xtaydi.",
        },
        { type: "image", image: 2 },
        {
            type: "list",
            items: [
                "Kod sizning repozitoriyingizda bo'lsin, pudratchi yoki xodim akkauntida emas. Bu shartnomaning birinchi bandi.",
                "Serverlar, domen va uchinchi tomon xizmatlari kompaniya yuridik shaxsiga rasmiylashtirilsin.",
                "Har oy qisqa texnik hujjat yangilansin: arxitektura, integratsiyalar ro'yxati, ishga tushirish tartibi.",
                "Kamida ikkinchi odam kodni ko'rgan bo'lsin — autsorsingda bu texnik rahbar, shtatda esa ikkinchi dasturchi yoki tashqi audit.",
                "Kirish huquqlari ro'yxati yuritilsin va xodim ketganda bir kun ichida yopilsin.",
            ],
        },
        {
            type: "p",
            text:
                "Bu beshta band deyarli hech narsa turmaydi, lekin aynan ular tizim to'xtaganda yuz millionlab so'mlik zararni oldini oladi.",
        },

        { type: "h2", text: "Qachon haqiqatan o'z jamoangiz kerak?" },
        {
            type: "p",
            text:
                "Bu bo'limni yozish biz uchun foydali emas, lekin usiz maqola halol bo'lmaydi. Quyidagi holatlarda autsorsing emas, o'z jamoangiz to'g'ri qaror.",
        },
        {
            type: "list",
            items: [
                "Dasturiy mahsulot sizning asosiy biznesingiz. Mahsulot sotilayotgan bo'lsa, u ustidagi bilim ichkarida bo'lishi shart.",
                "Tizim kuniga o'nlab marta o'zgaradi. Doimiy va zich ish oqimida ichki jamoa soat bo'yicha arzonroq chiqadi.",
                "Ma'lumot juda sezgir va uni tashqariga chiqarish mumkin emas. Bu holatda NDA yetarli emas deb hisoblasangiz, ichki jamoa yagona yo'l.",
                "Sizda allaqachon texnik rahbar bor. Rahbarsiz jamoa yollash eng qimmat xato: dasturchilar bor, yo'nalish yo'q.",
                "Gorizontingiz uch yildan uzun va byudjet barqaror. Jamoa qurish investitsiya, u qisqa loyihada o'zini oqlamaydi.",
            ],
        },
        {
            type: "p",
            text:
                "Qolgan hollarda aralash model ko'pincha eng arzoni bo'ladi: ichkarida bitta texnik rahbar yoki mahsulot egasi, tashqarida esa kerakli paytda kengayadigan jamoa.",
        },

        { type: "h2", text: "Qo'llab-quvvatlashsiz qolishning narxi" },
        {
            type: "p",
            text:
                "Xarajat qilmaslik ham xarajat. Faraz qiling, savdo tizimingiz ish kunining yarmida to'xtadi. Kuniga 200 ta buyurtma, o'rtacha chek 300 000 so'm, marja 25% — yarim kunlik to'xtash 7 500 000 so'm sof foydani olib ketadi.",
        },
        {
            type: "p",
            text:
                "Shu bitta hodisa yillik qo'llab-quvvatlash byudjetining sezilarli qismini yeydi. Ikkinchi, sekinroq yo'qotish — moslashmagan tizim sababli qo'lda bajariladigan ish: buxgalter oyiga qo'shimcha 30 soat sarflasa, bu yiliga 360 soat va u hech qanday qiymat qo'shmaydi.",
        },
        {
            type: "quote",
            text:
                "Tizim narxi uni qurish narxi emas. Tizim narxi — uni qurish va besh yil ishlatib turish narxi.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Qanday tanlash kerak: besh savol" },
        {
            type: "ol",
            items: [
                "Bu ish keyingi 12 oyda doimiymi yoki tugaydimi? Tugaydigan ish — loyiha, doimiy ish — jamoa masalasi.",
                "Oyiga necha soat real ish bor? 40–60 soat bo'lsa, shtat deyarli har doim qimmat.",
                "Tizim to'xtaganda biznes to'xtaydimi? Ha bo'lsa, SLA va almashtirish majburiyati shart.",
                "Sizda texnik qaror qabul qiladigan odam bormi? Yo'q bo'lsa, birinchi yollash aynan shu odam bo'lsin.",
                "Byudjet gorizonti qancha? Uch yildan qisqa bo'lsa, ichki jamoa qurish odatda o'zini oqlamaydi.",
            ],
        },
        {
            type: "p",
            text:
                "Beshta javobni yozib chiqsangiz, qaror odatda o'zi ko'rinadi. Agar javoblar aralash chiqsa — bu normal va aynan shunday holatda aralash model eng arzoni bo'ladi.",
        },
    ],

    faq: [
        {
            q: "O'z dasturchisi haqiqatda qancha turadi?",
            a: "Qo'lga tegadigan ish haqiga soliq va ajratmalar, texnika va ish joyi, ishga qabul davri hamda ta'til va kasallik kunlari qo'shiladi. Amaliy qoida: haqiqiy tannarx e'lon qilingan ish haqidan taxminan 1,5 barobar yuqori chiqadi. Oyiga 12 000 000 so'm qo'lga to'lanadigan mutaxassis kompaniyaga birinchi yilda 210–230 mln so'm atrofida tushadi.",
        },
        {
            q: "IT autsorsing Innobek'da qancha turadi?",
            a: "Bitta mutaxassis to'liq bandlikda oyiga 16 000 000 so'mdan boshlanadi. Loyiha menejeri va texnik rahbar bilan 3–4 kishilik jamoa 48 000 000 so'mdan, kengaytirilgan jamoa 110 000 000 so'mdan. Soatbay model ham bor: stavka 150 000 so'mdan, minimal hajm oyiga 20 soat. Aniq summa mutaxassis darajasi va yo'nalishga bog'liq, narxlarga QQS kiritilmagan.",
        },
        {
            q: "Autsorsing narxiga nima kirmaydi?",
            a: "Bulut serverlar, uchinchi tomon obunalari — to'lov tizimi, SMS xizmati, xarita, analitika — va tijorat litsenziyalari narxga kirmaydi. Ular sizning yuridik shaxsingizga rasmiylashtiriladi, ya'ni shartnoma tugagach ham sizda qoladi. Bu ataylab shunday qilinadi: xizmatlar pudratchi nomida bo'lsa, ajralish paytida ularni ko'chirish qo'shimcha vaqt va xarajat talab qiladi.",
        },
        {
            q: "Frilanser bilan ishlash qachon xavfli?",
            a: "Tizim to'xtaganda biznes ham to'xtaydigan holatda. Bunday loyihada uchta muammo chiqadi: hujjat yozilmaydi, kod bo'yicha huquq noaniq qoladi va mutaxassis istalgan kuni aloqaga chiqmay qo'yishi mumkin. Kichik va tugaydigan vazifalarda — bitta sahifa, bitta shakl — frilanser aksincha eng arzon va qulay yechim bo'ladi.",
        },
        {
            q: "Autsorsingda kod kimga tegishli bo'ladi?",
            a: "Kod sizga tegishli bo'lishi va sizning repozitoriyingizda saqlanishi shart — buni shartnomaning birinchi bandiga yozib qo'ying. Innobek'da kod birinchi kundanoq mijoz repozitoriysida yotadi va shartnoma tugaganda hujjatlar, kirish huquqlari hamda yopilmagan vazifalar ro'yxati rasman topshiriladi. Shartnomada intellektual mulk huquqi alohida band bilan belgilanadi.",
        },
        {
            q: "Ikkala modelni birga ishlatsa bo'ladimi?",
            a: "Ha, va amaliyotda bu eng barqaror sxema. Ichkarida bitta texnik rahbar yoki mahsulot egasi qoladi — u yo'nalishni va bilimni ushlab turadi. Tashqarida esa ehtiyojga qarab kengayadigan jamoa ishlaydi. Shunda siz ham nazoratni yo'qotmaysiz, ham bo'sh vaqt uchun to'liq oylik to'lamaysiz.",
        },
    ],

    cta: {
        h: "O'z holatingiz uchun hisobni birga qilamiz",
        p:
            "Vazifa hajmini va gorizontingizni eshitib, uchta model bo'yicha 12 oylik taqqoslashni tayyorlaymiz. Agar sizga autsorsing emas, o'z jamoangiz kerak degan xulosaga kelsak, buni ochiq aytamiz.",
        button: "Hisob so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/dasturchi-uch-model.webp",
            alt: "Uchta model: shtatdagi dasturchi, autsorsing jamoasi va frilanser yonma-yon ko'rsatilgan",
            caption: "Farq narxda emas, xarajat tarkibida va risk kimda turishida",
            prompt:
                "Three-panel conceptual illustration: an in-house desk with a name plate and empty chair, an external team working together in a studio, and a single freelancer with a laptop in a cafe; consistent flat-vector style, blue and warm neutral palette, light background, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/dasturchi-yillik-xarajat.webp",
            alt: "Uch model bo'yicha yillik to'liq xarajatning ustunli taqqoslash diagrammasi",
            caption: "Ish haqi — ustunning faqat pastki qismi",
            prompt:
                "Total cost of ownership stacked bar comparison for three staffing models: salary, taxes, workspace and idle time for in-house; project fee plus SLA for outsourcing; low hourly rate plus risk buffer for freelancer; clean data-viz on light background, blue, teal and amber, annual axis, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/dasturchi-risk-matritsa.webp",
            alt: "Bilimning bitta odamda to'planishi va uzluksizlik bo'yicha risk matritsasi",
            caption: "Eng katta zarar narxda emas, uzilishda paydo bo'ladi",
            prompt:
                "Risk matrix: four quadrants plotting knowledge concentration versus operational continuity, with three model dots placed across the quadrants and a shaded amber caution zone; clean minimal chart on light background, no readable text, no logos, 4:3",
        },
        {
            src: "/assets/img/projects/elma-lms.webp",
            alt: "ELMA LMS platformasi — uzoq muddat qo'llab-quvvatlanadigan tizim misoli",
            caption: "Tizim narxi — uni qurish va yillar davomida ishlatib turish narxi",
        },
    ],

    relatedServices: ["it-autsorsing", "texnik-qollab-quvvatlash", "ux-ui-dizayn"],
    relatedPosts: ["it-park-rezidentligi-2026", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const ru = {
    meta: {
        title: "Свой разработчик или аутсорсинг: расчёт на 12 месяцев",
        description:
            "Свой разработчик, аутсорсинг и фрилансер — полное сравнение расходов за 12 месяцев: оклад, налоги, рабочее место, отпуск, загрузка и риск потери знаний.",
        keywords: [
            "свой разработчик или аутсорсинг",
            "стоимость IT-аутсорсинга Узбекистан",
            "затраты на найм разработчика",
            "риски работы с фрилансером",
            "как собрать IT-команду",
            "полная стоимость разработчика в год",
        ],
    },
    h1: "Разработчик в штате, на аутсорсе или на фрилансе: расчёт за год",
    lead:
        "Многие руководители принимают это решение, глядя на один оклад, и к концу года выходят за бюджет. В полную стоимость входят ещё налоги, рабочее место, отпуск и простой. Ниже сравнение трёх моделей за 12 месяцев, скрытые статьи расходов и честная граница — когда собственная команда действительно нужна.",
    category: "Экономика проекта",
    readingTime: "10 минут",

    body: [
        {
            type: "p",
            text:
                "Вопрос обычно звучит так: «дешевле нанять разработчика или отдать работу компании?» Правильный ответ лежит в цифрах, но цифры нужно собрать целиком. Ниже готовая форма такого расчёта — подставьте в неё свои суммы.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Почему этот вопрос обострился в 2026 году?" },
        {
            type: "p",
            text:
                "Потому что система больше не строится один раз. По постановлению ПП-190 (23.05.2025) с 1 июля 2026 года при продаже маркированного товара код маркировки обязан отражаться в чеке онлайн-ККМ, а расчёты в оптовой торговле проводятся только в безналичной форме.",
        },
        {
            type: "p",
            text:
                "То есть кассовая программа, склад и документооборот вынуждены меняться каждый квартал. Поэтому вопрос «кто построил» стал менее важным, чем вопрос «кто сопровождает». Решение начинается именно с этой точки.",
        },

        { type: "h2", text: "В чём главное различие трёх моделей?" },
        {
            type: "p",
            text:
                "Разница не в цене, а в структуре расходов и в том, на ком лежит риск. Её можно сформулировать одной строкой для каждой модели.",
        },
        {
            type: "list",
            items: [
                "Свой разработчик — вы покупаете человека. Знания остаются внутри, но простой, отпуск и возможный уход тоже ваши.",
                "Аутсорсинг — вы покупаете результат. Налоги, техника и замена специалиста остаются у подрядчика, но часть знаний формируется снаружи.",
                "Фрилансер — вы покупаете часы. Самый дешёвый старт и самая слабая позиция по документам, гарантиям и непрерывности.",
            ],
        },
        {
            type: "p",
            text:
                "Универсального победителя здесь нет. Нормально, когда в одной компании работают все три модели сразу: постоянный продукт внутри, страницы под рекламные кампании на фрилансе, интеграции на аутсорсе.",
        },

        { type: "h2", text: "Как считается реальная годовая стоимость штатного разработчика?" },
        {
            type: "p",
            text:
                "Отдельная официальная статистика по зарплатам в IT не публикуется, поэтому суммы ниже — пример для подстановки ваших цифр, а не срез рынка. Ставки налогов уточните у своего бухгалтера по действующей редакции.",
        },
        {
            type: "ol",
            items: [
                "Зарплата на руки — например, 12 000 000 сум в месяц, то есть 144 000 000 сум за год.",
                "Сверху добавляются удерживаемый налог на доходы и социальный налог работодателя — в этом примере около 39 000 000 сум.",
                "Рабочее место: ноутбук, монитор, стол, лицензии и доля аренды офиса — в первый год обычно 25 000 000 – 35 000 000 сум.",
                "Найм: 1–3 месяца открытой вакансии, собеседования, испытательный срок. Это время вы оплачиваете, а результата за него не получаете.",
                "Отпуск, больничные и праздники: платите вы за 12 месяцев, а фактически отработанных месяцев выходит около 10,5.",
            ],
        },
        {
            type: "p",
            text:
                "Сумма из этих пяти пунктов обычно удивляет: оклад в 12 млн сум обходится компании примерно в 210–230 млн сум в год. То есть реальная месячная стоимость выше объявленной зарплаты примерно в полтора раза.",
        },

        { type: "h2", text: "Сравнительная таблица за 12 месяцев" },
        {
            type: "p",
            text:
                "Ниже сравнение трёх моделей для ситуации, когда специалист уровня middle нужен в течение года. Цифры по аутсорсингу — цены Innobek; колонка фрилансера дана диапазоном, поскольку ставки здесь разбросаны очень широко.",
        },
        {
            type: "table",
            head: ["Статья расходов", "Свой разработчик", "Аутсорсинг", "Фрилансер"],
            rows: [
                [
                    "Основная оплата (12 месяцев)",
                    "144 000 000 сум (12 млн на руки в месяц)",
                    "192 000 000 сум (от 16 млн в месяц, полная занятость)",
                    "По ставке, обычно самая низкая",
                ],
                [
                    "Налоги и отчисления",
                    "≈ 39 000 000 сум",
                    "Не входят — на стороне подрядчика",
                    "Зависит от формы договора, часто не оформляется",
                ],
                [
                    "Техника и рабочее место",
                    "25 000 000 – 35 000 000 сум",
                    "Не входит",
                    "Не входит",
                ],
                [
                    "Найм и испытательный срок",
                    "1–3 месяца без результата",
                    "Вход в проект за 1–2 недели",
                    "Несколько дней, но без проверки",
                ],
                [
                    "Отпуск, больничные, праздники",
                    "Из 12 месяцев отрабатывается ≈ 10,5",
                    "Потерянное время компенсируется подрядчиком",
                    "Не оплачивается, но сроки растягиваются",
                ],
                [
                    "Риск замены",
                    "Уход — снова 1–3 месяца и новая стоимость",
                    "Замена предусмотрена договором",
                    "Пропал — гарантий нет",
                ],
                [
                    "Итого за год (ориентир)",
                    "≈ 210 000 000 – 230 000 000 сум",
                    "От 192 000 000 сум (без НДС)",
                    "Самый низкий старт, самая высокая неопределённость",
                ],
            ],
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Отдельно стоит сказать о том, чего в таблице не видно: в цену аутсорсинга не входят облачные серверы, подписки сторонних сервисов (платежи, SMS, карты, аналитика) и коммерческие лицензии — они оформляются на ваше юрлицо. В варианте со штатным разработчиком эти расходы всё равно остаются на вас.",
        },

        { type: "h2", text: "Сколько часов разработчик работает на самом деле?" },
        {
            type: "p",
            text:
                "Именно эту часть расчёта упускают чаще всего. Штатному разработчику вы платите за полный месяц, но часов, потраченных на проект, оказывается заметно меньше.",
        },
        {
            type: "p",
            text:
                "Причины простые: совещания, мелкие просьбы соседних отделов, разбор технических сбоев, периоды ожидания. В небольших компаниях разработчик нередко ещё настраивает принтер и чинит Wi-Fi.",
        },
        {
            type: "p",
            text:
                "Поэтому сравнивайте стоимость часа. Если полная месячная стоимость 15 000 000 сум приходится на 100 реальных рабочих часов, час обходится в 150 000 сум. Почасовая модель аутсорсинга при этом стартует от 150 000 сум при минимуме 20 часов в месяц — то есть при низкой загрузке внешняя модель почти всегда дешевле.",
        },

        { type: "h2", text: "Аутсорсинг: сильные и слабые стороны" },
        {
            type: "p",
            text:
                "Сильная сторона — скорость входа и предсказуемый бюджет. Специалист подключается за 1–2 недели, налоги и техника уже внутри месячной суммы, и в бюджете не возникает неожиданных статей.",
        },
        {
            type: "p",
            text:
                "Структура цены тоже открытая. В Innobek один специалист на полной занятости стоит от 16 000 000 сум в месяц, команда из 3–4 человек с менеджером проекта и техлидом — от 48 000 000 сум, расширенная команда — от 110 000 000 сум. Есть и почасовая модель: ставка от 150 000 сум при минимальном объёме 20 часов в месяц.",
        },
        {
            type: "p",
            text:
                "Слабых сторон две. Первая — часть знаний формируется снаружи, поэтому требование вести документацию и держать репозиторий на вашем юрлице нужно зафиксировать в договоре. Вторая — есть минимальный срок: 2 месяца для одного специалиста и 3 месяца для команды. Для работы на неделю эта модель не подходит.",
        },

        { type: "h2", text: "Когда фрилансер оправдан, а когда обходится дорого?" },
        {
            type: "p",
            text:
                "С фрилансером выгодно работать в чётко очерченном классе задач: небольших, с видимым результатом и понятным финалом. Например, одна посадочная страница, логотип или форма отчёта.",
        },
        {
            type: "p",
            text:
                "Дорого получается в другом случае. Когда фрилансеру передают постоянно работающую систему, возникают три проблемы: документации нет, права на код размыты, а человек может перестать отвечать в любой день. После этого время нового специалиста на разбор чужого кода нередко обходится не дешевле, чем переписать проект заново.",
        },
        {
            type: "callout",
            text:
                "Рабочая граница: если при остановке системы останавливается и бизнес — это не задача для фрилансера. Здесь нужны гарантии, SLA и обязательство по замене исполнителя.",
        },

        { type: "h2", text: "Что такое «риск автобуса» и как его снизить?" },
        {
            type: "p",
            text:
                "Это распространённый в IT термин: что будет с проектом, если завтра один человек не выйдет на работу? В компаниях с единственным разработчиком ответ обычно неприятный — встанет полностью.",
        },
        { type: "image", image: 2 },
        {
            type: "list",
            items: [
                "Код должен лежать в вашем репозитории, а не в аккаунте подрядчика или сотрудника. Это первый пункт договора.",
                "Серверы, домен и сторонние сервисы оформляются на юрлицо компании.",
                "Раз в месяц обновляется короткий технический документ: архитектура, список интеграций, порядок развёртывания.",
                "Код должен видеть как минимум второй человек — на аутсорсе это техлид, в штате второй разработчик или внешний аудит.",
                "Ведите реестр доступов и закрывайте их в течение суток после ухода сотрудника.",
            ],
        },
        {
            type: "p",
            text:
                "Эти пять пунктов стоят почти ничего, но именно они предотвращают ущерб в сотни миллионов сум в момент, когда система встаёт.",
        },

        { type: "h2", text: "Когда собственная команда действительно нужна?" },
        {
            type: "p",
            text:
                "Писать этот раздел нам невыгодно, но без него материал был бы нечестным. В перечисленных ниже случаях правильное решение — своя команда, а не аутсорсинг.",
        },
        {
            type: "list",
            items: [
                "Программный продукт и есть ваш основной бизнес. Если продукт продаётся, знания о нём обязаны оставаться внутри.",
                "Система меняется по несколько раз в день. При плотном постоянном потоке задач внутренняя команда дешевле в пересчёте на час.",
                "Данные слишком чувствительны и не могут покидать контур. Если вы считаете, что NDA здесь недостаточно, внутренняя команда — единственный путь.",
                "У вас уже есть технический руководитель. Нанимать команду без него — самая дорогая ошибка: разработчики есть, направления нет.",
                "Горизонт длиннее трёх лет и бюджет стабилен. Сборка команды — это инвестиция, на коротком проекте она не окупается.",
            ],
        },
        {
            type: "p",
            text:
                "В остальных случаях самой дешёвой чаще оказывается смешанная модель: внутри один технический руководитель или владелец продукта, снаружи — команда, которая расширяется под потребность.",
        },

        { type: "h2", text: "Сколько стоит остаться без сопровождения?" },
        {
            type: "p",
            text:
                "Не тратить — тоже расход. Допустим, торговая система встала на половину рабочего дня. При 200 заказах в день, среднем чеке 300 000 сум и марже 25% полдня простоя уносят 7 500 000 сум чистой прибыли.",
        },
        {
            type: "p",
            text:
                "Один такой случай съедает заметную часть годового бюджета на поддержку. Вторая, более медленная потеря — ручная работа из-за неадаптированной системы: если бухгалтер тратит дополнительные 30 часов в месяц, за год набегает 360 часов, не создающих никакой ценности.",
        },
        {
            type: "quote",
            text:
                "Стоимость системы — это не стоимость её создания. Это стоимость создания плюс пять лет эксплуатации.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Как выбрать: пять вопросов" },
        {
            type: "ol",
            items: [
                "Эта работа постоянная на ближайшие 12 месяцев или конечная? Конечная — это проект, постоянная — вопрос команды.",
                "Сколько реальных часов работы в месяц? Если 40–60, штат почти всегда дороже.",
                "Останавливается ли бизнес при остановке системы? Если да, нужны SLA и обязательство по замене.",
                "Есть ли у вас человек, принимающий технические решения? Если нет, первым наймом должен стать именно он.",
                "Каков горизонт бюджета? Короче трёх лет — сборка внутренней команды обычно не окупается.",
            ],
        },
        {
            type: "p",
            text:
                "Если выписать пять ответов, решение обычно проявляется само. Смешанные ответы — это нормально, и как раз в такой ситуации комбинированная модель оказывается самой дешёвой.",
        },
    ],

    faq: [
        {
            q: "Сколько на самом деле стоит штатный разработчик?",
            a: "К зарплате на руки добавляются налоги и отчисления, техника и рабочее место, период найма, а также отпускные и больничные дни. Рабочее правило: реальная стоимость примерно в полтора раза выше объявленного оклада. Специалист с 12 000 000 сум на руки обходится компании в первый год примерно в 210–230 млн сум.",
        },
        {
            q: "Сколько стоит IT-аутсорсинг в Innobek?",
            a: "Один специалист на полной занятости — от 16 000 000 сум в месяц. Команда из 3–4 человек с менеджером проекта и техлидом — от 48 000 000 сум, расширенная команда — от 110 000 000 сум. Есть почасовая модель: ставка от 150 000 сум при минимальном объёме 20 часов в месяц. Точная сумма зависит от уровня специалиста и направления, цены указаны без НДС.",
        },
        {
            q: "Что не входит в стоимость аутсорсинга?",
            a: "Облачные серверы, подписки сторонних сервисов — платёжные системы, SMS, карты, аналитика — и коммерческие лицензии в цену не входят. Они оформляются на ваше юридическое лицо и остаются у вас после завершения договора. Так сделано намеренно: если сервисы записаны на подрядчика, их перенос при расставании стоит дополнительного времени и денег.",
        },
        {
            q: "Когда работа с фрилансером становится рискованной?",
            a: "Когда при остановке системы останавливается бизнес. В таком проекте проявляются три проблемы: документация не пишется, права на код остаются размытыми, а специалист может перестать выходить на связь в любой момент. На небольших конечных задачах — одна страница, одна форма — фрилансер, наоборот, самое дешёвое и удобное решение.",
        },
        {
            q: "Кому принадлежит код при аутсорсинге?",
            a: "Код должен принадлежать вам и храниться в вашем репозитории — зафиксируйте это первым пунктом договора. В Innobek код с первого дня лежит в репозитории клиента, а при завершении сотрудничества официально передаются документация, доступы и список незакрытых задач. Права на интеллектуальную собственность прописываются отдельным пунктом.",
        },
        {
            q: "Можно ли совмещать обе модели?",
            a: "Да, и на практике это самая устойчивая схема. Внутри остаётся один технический руководитель или владелец продукта — он держит направление и знания. Снаружи работает команда, которая расширяется под текущую потребность. Так вы не теряете контроль и одновременно не платите полный оклад за простой.",
        },
    ],

    cta: {
        h: "Посчитаем вашу ситуацию вместе",
        p:
            "Разберём объём задач и горизонт планирования и подготовим сравнение трёх моделей на 12 месяцев. Если придём к выводу, что вам нужна своя команда, а не аутсорсинг, скажем об этом прямо.",
        button: "Запросить расчёт",
    },

    images: [
        {
            src: "/assets/img/blog/dasturchi-uch-model.webp",
            alt: "Три модели рядом: разработчик в штате, команда на аутсорсе и фрилансер",
            caption: "Разница не в цене, а в структуре расходов и в том, на ком лежит риск",
            prompt:
                "Three-panel conceptual illustration: an in-house desk with a name plate and empty chair, an external team working together in a studio, and a single freelancer with a laptop in a cafe; consistent flat-vector style, blue and warm neutral palette, light background, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/dasturchi-yillik-xarajat.webp",
            alt: "Столбчатое сравнение полной годовой стоимости по трём моделям найма",
            caption: "Оклад — это лишь нижняя часть столбца",
            prompt:
                "Total cost of ownership stacked bar comparison for three staffing models: salary, taxes, workspace and idle time for in-house; project fee plus SLA for outsourcing; low hourly rate plus risk buffer for freelancer; clean data-viz on light background, blue, teal and amber, annual axis, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/dasturchi-risk-matritsa.webp",
            alt: "Матрица рисков: концентрация знаний в одном человеке и непрерывность работы",
            caption: "Основной ущерб возникает не в цене, а в простое",
            prompt:
                "Risk matrix: four quadrants plotting knowledge concentration versus operational continuity, with three model dots placed across the quadrants and a shaded amber caution zone; clean minimal chart on light background, no readable text, no logos, 4:3",
        },
        {
            src: "/assets/img/projects/elma-lms.webp",
            alt: "Платформа ELMA LMS — пример системы с длительным сопровождением",
            caption: "Стоимость системы — это её создание плюс годы эксплуатации",
        },
    ],

    relatedServices: ["it-autsorsing", "texnik-qollab-quvvatlash", "ux-ui-dizayn"],
    relatedPosts: ["it-park-rezidentligi-2026", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const content = { uz, ru };

export default content;
